import { FaqCard } from "../../Components/FaqCard/FaqCard";

function Faq() {
  return <FaqCard />;
}

export default Faq;
